import { render, staticRenderFns } from "./QuickSearch.vue?vue&type=template&id=99da0518&scoped=true&"
import script from "./QuickSearch.vue?vue&type=script&lang=ts&"
export * from "./QuickSearch.vue?vue&type=script&lang=ts&"
import style0 from "./QuickSearch.vue?vue&type=style&index=0&id=99da0518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99da0518",
  null
  
)

export default component.exports